"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const Row_1 = require("../../Row");
const Col_1 = require("../../Col");
const device_1 = require("../../../device");
exports.PageHeader = styled_components_1.default(Row_1.Row) `
  background: ${(props) => props.theme.backgrounds.pageHeader};
  border-top: 0;
  padding: 15px 10px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  justify-content: space-between;
  align-items: baseline;
`;
exports.PageTitle = styled_components_1.default.h2 `
  font-size: 18px;
  color: ${(props) => props.theme.colors.pageHeaderText};
  margin-top: 4px;
`;
exports.MenuButtonContainer = styled_components_1.default(Col_1.Col) `
  color: #fff;

  @media ${device_1.device.tablet} {
    display: none;
  }
`;
exports.MenuButton = styled_components_1.default.button `
  color: #fff;
`;
exports.PageUser = styled_components_1.default.div `
  font-size: 10pt;
  color: #fff;
  margin-top: 3px;

  @media not ${device_1.device.tablet} {
    border-top: 1px solid;
  }
`;
exports.PageHeaderButtons = styled_components_1.default.span `
  margin-left: 20px;
`;
exports.PageUserButton = styled_components_1.default(react_router_dom_1.Link) `
  font-size: 12pt;
  color: #fff;
  padding: 7px;

  &:hover {
    color: ${props => polished_1.lighten(0.3, props.theme.colors.gray)};
  }
`;
exports.PageNames = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  flex: 1;

  @media not ${device_1.device.tablet} {
    flex-direction: column;
    display: none;
  }
  @media ${device_1.device.tablet} {
    flex-direction: row;
  }
`;
